import { render, staticRenderFns } from "./UserTransactions.vue?vue&type=template&id=63f09dcd&scoped=true"
import script from "./UserTransactions.vue?vue&type=script&lang=js"
export * from "./UserTransactions.vue?vue&type=script&lang=js"
import style0 from "./UserTransactions.vue?vue&type=style&index=0&id=63f09dcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f09dcd",
  null
  
)

export default component.exports